import { Form, Table, Typography, Input, Button, Progress, Card, Empty } from 'antd';
import { RightOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { Row, Col } from "react-bootstrap";
import ButtonMui from '@mui/material/Button';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { v4 } from 'uuid'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Popconfirm from 'antd/es/popconfirm';
import Modal from 'antd/es/modal';
import { useSelector, useDispatch } from 'react-redux'
import {
    setFile, getFile, setMemberSuccess, getMemberSuccess, setMemberFail, getMemberFail, getStyle, getBizID, getObjective, getFileID, getServices
} from '../../../libs/todoSlice'
import axios from "axios";
import { useCookies } from "react-cookie";
import { useNavigate, useParams } from 'react-router-dom';
import fontColor from '../../../lib/fontColor';
import PreRegisterAddMemberSuccess from './PreRegisterAddMemberSuccess';
import PreRegisterAddMemberFail from './PreRegisterAddMemberFail';
import { resolvePreRegisterConfig, buildFieldColumns, buildEmptyFormValues } from '../../../lib/preRegisterConfig';

const PreRegisterAddMember = ({ backStep, typeTemplate }) => {
    const [step, setStep] = useState('check');
    // eslint-disable-next-line no-unused-vars
    const [cookie, setCookie] = useCookies(['account'])
    const dispatch = useDispatch()
    const style = useSelector(getStyle)
    const services = useSelector(getServices)
    const [searchvalue, setSearchValue] = useState('')

    const objective = useSelector(getObjective)
    const config = resolvePreRegisterConfig(objective)
    const member = useSelector(getFile)

    // function search top — ใช้ primarySearchField จาก config แทน hardcode cid
    const searchFunc = () => {
        if (searchvalue === '') {
            setData(dataDefault)
        } else {
            const field = config.primarySearchField
            const param = dataDefault.filter((item) => item[field] && item[field].toString().includes(searchvalue))
            setData(param)
        }
    }
    const clearSearch = () => {
        setSearchValue('')
        setData(dataDefault)
    }
    // end function search top

    // function show member (ข้อมูลที่เพิ่งอัปโหลดจาก excel ก่อนกดยืนยันสร้าง)
    useEffect(() => {
        

        const prepared = member.map((item, index) => ({
            index: index + 1,
            key: v4(),
            ...Object.fromEntries(config.fields.map(f => [f.key, item[f.key]])),
        }))
        setData(prepared)
        setDataDefault(prepared)
    }, [member, config])
    // end function show member

    // tab in success step
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const member_fail = useSelector(getMemberFail)
    useEffect(() => {
        if (member_fail.length > 0) {
            setValue('2')
        }
    }, [member_fail]);
    // end tab in success step

    // function steps progress
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['ตรวจสอบข้อมูล', 'กำลังดำเนินการ', 'สำเร็จ'];
    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 22,
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor: style.primary_color ?? '#053075',
            },
            color: fontColor(style.primary_color)
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor: style.primary_color ?? '#053075',
            },
            color: fontColor(style.primary_color)
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 3,
            border: 0,
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
            borderRadius: 1,
        },
    }));
    const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        border: 'solid',
        borderColor: '#F5F5F5',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
        zIndex: 1,
        color: '#E0E0E0',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.active && {
            backgroundColor: '#F3F5FA',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: style.primary_color ?? '#053075',
        }),
        ...(ownerState.completed && {
            backgroundColor: style.primary_color ?? '#053075',
        }),
    }));
    function ColorlibStepIcon(props) {
        const { active, completed, className } = props;
        const icons = {
            1: <FormatListBulletedIcon />,
            2: <HourglassTopIcon />,
            3: <CheckIcon />,
        };
        return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                {icons[String(props.icon)]}
            </ColorlibStepIconRoot>
        );
    }
    // end function steps progress

    // function edit table (แก้ field ได้ก่อนกดยืนยัน — ใช้ schema จาก config)
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [dataDefault, setDataDefault] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({ ...buildEmptyFormValues(config), ...record });
        setEditingKey(record.key);
    };
    const save = async (key) => {
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, { ...item, ...row });
                setData(newData);
                setDataDefault(newData)
                dispatch(setFile({ file: newData }))
                setEditingKey('');
            }
        } catch (err) {
        }
    };
    const handleDelete = (key) => {
        const newData = data.filter((item) => item.key !== key);
        setData(newData);
        dispatch(setFile({ file: newData }))
    };
    // end edit table

    const navigate = useNavigate()
    const file = useSelector(getFile)
    const fileID = useSelector(getFileID)
    const successList = useSelector(getMemberSuccess)
    const params = useParams()
    const failList = useSelector(getMemberFail)
    const sendExcelSummary = async () => {
        await axios({
            method: 'PATCH',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
            data: {
                _id: fileID,
                total: `${file.length}`,
                success: `${successList.length}`,
                fail: `${failList.length}`,
                successDetail: successList,
                objective: objective,
                failDetail: failList
            }
        }).then(() => {
        }, ({ response }) => {
            const { status } = response
            if (status === 401) {
                navigate(`/${params.prefix}`)
            }
        })
    }

    const fieldColumns = buildFieldColumns(config, { editable: true, isEditing, data, setData })

    const columns = [
      {
        title: "ลำดับที่",
        dataIndex: "index",
        width: 100,
        fixed: "left",
        render: (index) => index,
      },
      ...fieldColumns,
      {
        title: "operation",
        dataIndex: "operation",
        width: 200,
        fixed: "right",
        render: (_, record) => {
          const editable = isEditing(record);
          return editable ? (
            <span>
              <Button
                type="primary"
                onClick={() => save(record.key)}
                style={{ marginRight: 8, background: "#53BE35" }}
              >
                บันทึก
              </Button>
              <Popconfirm
                title="Sure to cancel?"
                onConfirm={() => {
                  setEditingKey("");
                  setData(dataDefault);
                }}
              >
                <Button>ยกเลิก</Button>
              </Popconfirm>
            </span>
          ) : (
            <>
              <Typography.Link onClick={() => edit(record)}>
                <ModeEditOutlinedIcon style={{ color: "#053075" }} />
              </Typography.Link>
              {data.length >= 1 ? (
                <Popconfirm
                  title="ต้องการลบข้อมูลนี้ใช่หรือไม่"
                  onConfirm={() => handleDelete(record.key)}
                >
                  <DeleteOutlinedIcon
                    style={{ color: "red", cursor: "pointer", marginLeft: 8 }}
                  />
                </Popconfirm>
              ) : null}
            </>
          );
        },
      },
    ];

    // function register member — ใช้ config กลางแทนการยิง endpoint ตรงๆ
    const importMemberSuccess = useSelector(getMemberSuccess)
    const importMemberFail = useSelector(getMemberFail)
    const [count, setcount] = useState(0)
    const statesuccessone = useSelector(getMemberSuccess)
    const statefailone = useSelector(getMemberFail)
    const [stateAllOne, setStateAllOne] = useState([])
    const business_id = useSelector(getBizID)

    const preRegister = async () => {
      let prepare = [];
      let prepare_fail = [];
      const prepare_data = member;

      for (const index of prepare_data.keys()) {
        const members = prepare_data[index];
        try {
          const { data } = await axios({
            method: "POST",
            url: config.endpoint,
            data: config.buildPayload(members, {
              business_id,
              objective,
              services,
              file_id: fileID,
            }),
          });

          const result = data?.data?.[0];
          const itemFailed = result && Number(result.fail) > 0;

          if (itemFailed) {
            const failInfo = result.failDetail?.[0];
            prepare_fail.push({
              request: { ...members, key: v4() },
              response: failInfo?.response ?? data,
            });
          } else {
            prepare.push({
              request: { ...members, key: v4() },
              response: data,
            });
          }
          setcount(index + 1);
        } catch (err) {
          const { response } = err;
          prepare_fail.push({
            request: { ...members, key: v4() },
            response: response?.data,
          });
          setcount(index + 1);
        }
        dispatch(
          setMemberSuccess({
            member_success: [...statesuccessone, ...prepare],
          }),
        );
        dispatch(setMemberFail({ member_fail: [...prepare_fail] }));
        setStateAllOne([...prepare, ...prepare_fail]);
      }
    };

    const [modalbeforeSuccess, setModalBeforeSuccess] = useState(false);
    useEffect(() => {
        if (step !== 'success') {
            if (statesuccessone.length + statefailone.length === member.length && member.length !== 0) {
                setActiveStep(2)
                setTimeout(() => {
                    setStep('success')
                    setModalBeforeSuccess(true)
                    setActiveStep(3)
                }, 1500)
            }
        }
    }, [statesuccessone, statefailone, stateAllOne])

    useEffect(() => {
        if (modalbeforeSuccess) {
            sendExcelSummary()
        }
    }, [modalbeforeSuccess])
    // end function register member

    const alertManagement = () => {
        const message = `ข้อมูล Pre Registration ด้วย ${config.entityLabel}`
        if (importMemberSuccess.length !== 0) {
            return (
                <>
                    สร้าง {message} แล้ว <br />
                    {importMemberSuccess.length} รายการ จาก {file.length} รายการ
                </>
            )
        }
        return (<>ไม่มีการสร้าง {message}</>)
    }

    const customLocale = {
        emptyText: (<Empty description="ไม่มีข้อมูล" />)
    };

    return (
        <>
            <Row>
                <Col className="d-flex justify-content-start">
                    <h3
                        style={{ margin: 0, padding: 0, border: 'none', cursor: 'pointer' }}
                        onClick={() => { backStep() }}
                    >
                        <ArrowBackIosIcon />
                        เพิ่มรายชื่อ
                    </h3>
                </Col>
            </Row>
            <Row style={{ marginBottom: '40px', marginTop: '20px' }}>
                <Stack sx={{ width: '100%' }} spacing={4}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                        {steps.map((label, key) => (
                            <Step key={key}>
                                <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Stack>
            </Row>
            {
                {
                    "check": (
                        <>
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Col xl={12} lg={12} md={6} sm={12} xs={12}>
                                    <h5>ค้นหา</h5>
                                </Col>
                                <Col xl={5} lg={6} md={6} sm={12} xs={12}>
                                    <Input.Group compact>
                                        <Input
                                            value={searchvalue}
                                            size="large"
                                            style={{ width: 'calc(100% - 40px)' }}
                                            placeholder={config.searchPlaceholder}
                                            onChange={({ target }) => setSearchValue(target.value)}
                                            onPressEnter={() => searchFunc()}
                                            suffix={
                                                <CloseOutlined
                                                    onClick={() => clearSearch()}
                                                    style={{ color: 'rgba(0,0,0,.45)' }}
                                                />
                                            }
                                        />
                                        <Button
                                            icon={<SearchOutlined />}
                                            size="large"
                                            style={{ borderRadius: '0px 4px 4px 0px' }}
                                            onClick={() => searchFunc()}
                                        />
                                    </Input.Group>
                                </Col>
                            </Row>
                            <Form form={form} component={false}>
                                <Table
                                    locale={customLocale}
                                    bordered
                                    dataSource={data}
                                    columns={columns}
                                    rowClassName="editable-row"
                                    scroll={{ x: 600, y: 400 }}
                                />
                            </Form>
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Col className='d-flex justify-content-start'>
                                    <ButtonMui
                                        sx={!!style.secondary_color && {
                                            borderColor: `${style.secondary_color} !important`,
                                            color: `${style.secondary_color} !important`,
                                            border: ' 1px solid'
                                        }}
                                        size='large'
                                        onClick={() => { backStep(); setActiveStep(0) }}>
                                        ยกเลิก
                                    </ButtonMui>
                                </Col>
                                <Col className='d-flex justify-content-end'>
                                    <ButtonMui
                                        sx={!!style.secondary_color && {
                                            background: `${style.secondary_color} !important`,
                                            color: fontColor(style.secondary_color)
                                        }}
                                        size='large'
                                        hidden={member.length === 0}
                                        onClick={() => {
                                            preRegister()
                                            setStep('pending')
                                            setActiveStep(1)
                                        }}>
                                        ดำเนินการสร้าง <RightOutlined />
                                    </ButtonMui>
                                </Col>
                            </Row>
                        </>
                    ),
                    "pending": (
                        <>
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Col className='d-flex justify-content-center'>
                                    <Progress
                                        type="circle"
                                        percent={(count / file.length) * 100}
                                        strokeColor={{
                                            '0%': '#86DB0A',
                                            '25%': '#A4E311',
                                            '50%': '#F0F420',
                                            '70%': '#FFCC01',
                                            '100%': '#FF9801',
                                        }}
                                        format={() => <> {file.length} <br /><span style={{ fontSize: '12px' }}>รายการทั้งหมด</span> </>}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Col className='d-flex justify-content-center'>
                                    <Card style={{ width: '100%', boxShadow: '4px 4px 16px rgba(5, 48, 117, 0.12)' }}>
                                        <div className='row'>
                                            <div className='col' style={{ textAlign: 'start' }}>
                                                <b>สร้างรายชื่อด้วย {config.entityLabel}</b>
                                            </div>
                                            <div className='col' style={{ textAlign: 'end' }}>
                                                <CloseOutlined />
                                            </div>
                                        </div>
                                        <p style={{ paddingTop: '20px' }}>
                                            <Progress percent={parseInt((count / file.length) * 100)} status="active" strokeColor='#53BE35' />
                                        </p>
                                    </Card>
                                </Col>
                            </Row>
                        </>
                    ),
                    "success": (
                        <>
                            <Row style={{ marginBottom: '20px', marginTop: '20px' }}>
                                <Box sx={{ width: '100%', typography: 'body1' }}>
                                    <TabContext value={value}>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary"
                                                TabIndicatorProps={{
                                                    sx: !!style.secondary_color && {
                                                        backgroundColor: `${style.secondary_color} !important`,
                                                        color: fontColor(style.secondary_color)
                                                    }
                                                }}>
                                                <Tab label={`รายการที่สำเร็จ (${importMemberSuccess.length})`} value="1" />
                                                <Tab label={`รายการที่ไม่สำเร็จ (${importMemberFail.length})`} value="2" />
                                            </TabList>
                                        </Box>
                                        <TabPanel value="1">
                                            <PreRegisterAddMemberSuccess memberOneSuccess={statesuccessone} />
                                        </TabPanel>
                                        <TabPanel value="2">
                                            <PreRegisterAddMemberFail />
                                        </TabPanel>
                                    </TabContext>
                                </Box>
                            </Row>
                            <Modal
                                title={importMemberSuccess.length != 0 ? "ทำรายการสำเร็จ" : "ทำรายการไม่สำเร็จ"}
                                centered
                                open={modalbeforeSuccess}
                                onOk={() => setModalBeforeSuccess(false)}
                                onCancel={() => setModalBeforeSuccess(false)}
                                footer={null}
                            >
                                <Row>
                                    <Col className='d-flex justify-content-center'>
                                        {importMemberSuccess.length != 0 ?
                                            <CheckIcon style={{ background: '#53BE35', borderRadius: '50%', fontSize: '50px', color: '#fff', padding: '10px' }} />
                                            :
                                            <CloseIcon style={{ background: '#F37959', borderRadius: '50%', fontSize: '50px', color: '#fff', padding: '10px' }} />
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ paddingTop: '30px', paddingBottom: '30px' }}>
                                    <Col className='d-flex justify-content-center text-center'>
                                        {alertManagement()}
                                    </Col>
                                </Row>
                            </Modal>
                        </>
                    ),
                }[step]
            }
        </>
    );
};
export default PreRegisterAddMember;